import { render } from "./AppAccordion.vue?vue&type=template&id=8d116986"
import script from "./AppAccordion.vue?vue&type=script&lang=js"
export * from "./AppAccordion.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__